import { schemaImage } from 'apps/website/src/morphismSchema/components/schemaImage';
import { schemaDatoButton } from 'apps/website/src/morphismSchema/schemaDatoButton';
import { MenuCard } from 'libs/brand-system/src/components/MenuCard';
import { ButtonNavbar } from 'libs/growth-platform-brand-system-v2/src/components/ButtonV2';
import { Image } from 'libs/growth-platform-brand-system-v2/src/components/Image';
import Arrow from 'libs/growth-platform-brand-system-v2/src/foundations/pictograms/arrow.svg';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { ButtonTracking } from 'libs/growth-platform-brand-system-v2/src/utils/tracking/ButtonTracking';
import morphism from 'morphism';
import React from 'react';
import { isBlogArticle, isClientLink } from './SubMenuContent';
import { SectionBottomType } from './types';
import { getMenuTrackEvent } from 'libs/growth-platform-brand-system-v2/src/utils/tracking';
import { ImageProps } from '@payfit/growth-platform-brand-system-v2/components/Image/types';

interface SectionBottomProps {
  index: number;
  sectionBottom: SectionBottomType;
  locale: string;
}

export const SectionBottom: React.FC<SectionBottomProps> = ({
  index: indexSection,
  sectionBottom,
  locale,
}) => {
  if (!sectionBottom) return null;

  if (sectionBottom.__typename === 'DatoCmsNbSubmenuCard') {
    const { title, subtitle, tagText, image, pixelDensity, internalLink, url } =
      sectionBottom;

    const _image = morphism(schemaImage, {
      ...image,
      pixelDensity,
    }) as ImageProps;
    const imageComponent = (
      <Image
        {..._image}
        className={classNames('object-contain xl:object-cover w-full h-full')}
        sizes={'300px'}
      />
    );

    let linkData;
    if (internalLink) {
      linkData = {
        internalUrl: internalLink,
        title,
        locale,
        isBlogArticle: isBlogArticle(sectionBottom.__typename),
        isClientLink: isClientLink(sectionBottom.__typename),
      };
    } else {
      linkData = {
        url,
        title,
      };
    }

    const { as, __typename, color, variant, ...linkProps } = morphism(
      schemaDatoButton,
      linkData,
    );
    const trackEvent = getMenuTrackEvent({
      locale,
      menuItem: sectionBottom,
    });

    return (
      <div
        className={classNames(
          'SectionBottom mt-40 mb-40 xl:mt-0 xl:mb-0',
          'pb-3 xl:pl-5 xl:pr-5 xl:pb-5',
        )}
      >
        <ButtonTracking
          component={as}
          {...linkProps}
          className="block"
          section={`Menu_${indexSection}_Submenu_SectionBottom_Card`}
          index={0}
          labelTracking={title}
          trackEvent={trackEvent}
        >
          <MenuCard
            title={title}
            subtitle={subtitle}
            image={imageComponent}
            tags={
              tagText
                ? [{ title: tagText, isDark: true, size: 'small' }]
                : undefined
            }
          />
        </ButtonTracking>
      </div>
    );
  }

  if (sectionBottom.__typename === 'DatoCmsNbButton') {
    const { title, variant, color, ...dataButton } = morphism(
      schemaDatoButton,
      {
        ...sectionBottom,
        locale,
        isClientLink: isClientLink(sectionBottom.internalUrl?.__typename),
        isBlogArticle: isBlogArticle(sectionBottom.internalUrl?.__typename),
      },
    );

    const trackEvent = getMenuTrackEvent({
      locale,
      menuItem: sectionBottom,
    });

    return (
      <div
        className={classNames(
          'SectionBottom',
          'h-[62px]',
          'bg-lang-31',
          'flex',
          'items-center',
          'justify-between',
          'text-16',
          'px-20',
          'py-8',
          'w-full',
          'xl:my-0',
          'rounded-[20px] xl:rounded-none',
        )}
      >
        <ButtonTracking
          component={ButtonNavbar}
          section={`Menu_${indexSection}_Submenu_SectionBottom`}
          index={0}
          {...dataButton}
          labelTracking={title}
          trackEvent={trackEvent}
          variant="minimal"
          className="flex items-center justify-start w-full gap-x-8"
        >
          {title}
          <Arrow className={classNames('w-[16px] h-12 fill-current')} />
        </ButtonTracking>
      </div>
    );
  }

  return null;
};
